import { Injectable, signal } from '@angular/core';
import { RemoteConfigService } from './RemoteConfig.service';

@Injectable({ providedIn: 'root' })
export class AppVisibilityService {
  readonly isMaintenanceMode = signal(false);

  constructor(private remoteConfig: RemoteConfigService) {}

  async init(): Promise<void> {
    await this.remoteConfig.init();
    const maintenanceMode = this.remoteConfig.getBoolean('homigo');
    console.log('[Firebase Remote Config] maintenance_mode:', maintenanceMode);
    this.isMaintenanceMode.set(maintenanceMode);
  }
}
